var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#C2EED9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9253 7.3636L12.5078 5.63818L7.99982 14.5671L11.4174 16.2926L15.9253 7.3636Z",
    fill: "#40D9B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4156 8.33138L11.998 6.60596L11.2117 8.16343L14.6293 9.88885L15.4156 8.33138Z",
    fill: "#C2EED9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 7.5244L12.4316 5.82293C12.7962 5.09373 13.7077 4.78989 14.4369 5.15449L15.1661 5.51909C15.9561 5.8837 16.1992 6.7952 15.8346 7.5244Z",
    fill: "#40D9B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48201 17.6723C8.36047 16.6393 8.17817 15.6063 8.05664 14.5732L11.4596 16.2747C10.4265 16.7001 9.45428 17.1862 8.48201 17.6723Z",
    fill: "#40D9B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4833 17.6725C8.42254 17.1864 8.36177 16.6395 8.24023 16.1533C8.78714 16.4572 9.33404 16.761 9.88094 17.0648C9.3948 17.1864 8.96944 17.4294 8.4833 17.6725Z",
    fill: "#40D9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.29f7b344139ee43216eec142a53dfe66.svg";
export { ForwardRef as ReactComponent };